export function getGAClientId(cookie: string | null) {
	const cookieMap: Record<string, string> = {};
	cookie?.split(';').forEach(function (el) {
		var splitCookie = el.split('=');
		var key = splitCookie[0].trim();
		var value = splitCookie[1];
		cookieMap[key] = value;
	});
	return cookie ? cookieMap['_ga']?.substring(6) : '';
}
